export type PrState = 'merged' | 'open' | 'closed' | 'all' | '!open';
